/**
 * Builds a properly formatted query string based on a set of input key/value params.
 * Note: Ignores any keys that do not have a value
 *
 * @method buildQueryString
 * @param  {Object} params [Set of key/value pairs]
 * @return {String}        [The resulting query string built from the input params]
 */
const buildQueryString = (params) => {
  return (
    Object
      .keys(params)
      .reduce((result, key) => {
        if (params[key]) {
          result.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
        }
        return result;
      }, [])
      .join('&')
  );
}

export default buildQueryString;



// WEBPACK FOOTER //
// ./src/client/utils/build-query-string.js